"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties")),
    _react = _interopRequireWildcard(require("react")),
    _fileTypes = require("../../../common/constants/fileTypes"),
    _utils = require("../../../common/utils"),
    _ImagePreview = _interopRequireDefault(require("./ImagePreview")),
    _VideoPreview = _interopRequireDefault(require("./VideoPreview")),
    _AudioPreview = _interopRequireDefault(require("./AudioPreview")),
    _FontPreview = _interopRequireDefault(require("./FontPreview")),
    _OtherPreview = _interopRequireDefault(require("./OtherPreview"));

require("../styles/_asset-preview.scss");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

function hasValidAssetFile(a) {
  var b = a.assetFiles,
      c = a.type;
  if (!b) return !1;
  var d = b.ORIGINAL,
      e = b.SD,
      f = b.STREAM;
  return d && d.sourceUrl || c === _fileTypes.VIDEO && e && e.sourceUrl || c === _fileTypes.VIDEO && f && f.sourceUrl && f.fragments.length;
}

function getPreviewComponentFromAsset(a, b) {
  var c = b.canPlayVideo,
      d = b.canPlayAudio;
  if (!a) return {
    component: _OtherPreview["default"],
    type: _fileTypes.OTHER
  };
  if ((0, _utils.assetHasError)(a)) return {
    component: _OtherPreview["default"],
    type: _fileTypes.OTHER,
    assetError: !0
  };
  if ((0, _utils.isAssetMissing)(a)) return {
    component: _OtherPreview["default"],
    type: _fileTypes.OTHER,
    assetMissing: !0
  };
  var e = a.loadedPercent,
      f = a.metaData,
      g = a.filename,
      h = a.assetFiles,
      i = (0, _utils.getTypeFromAsset)({
    metaData: f,
    filename: g
  }),
      j = hasValidAssetFile({
    assetFiles: h,
    type: i
  });
  return (void 0 === e || 100 === e) && j ? i === _fileTypes.IMAGE || i === _fileTypes.HEIC ? {
    component: _ImagePreview["default"],
    type: i
  } : i === _fileTypes.VIDEO ? {
    component: _VideoPreview["default"],
    type: i,
    canPlayVideo: c
  } : i === _fileTypes.FONT ? {
    component: _FontPreview["default"],
    type: i
  } : i !== _fileTypes.AUDIO || d ? i === _fileTypes.AUDIO ? {
    component: _AudioPreview["default"],
    type: i
  } : {
    component: _OtherPreview["default"],
    type: i
  } : {
    component: _OtherPreview["default"],
    type: i
  } : {
    component: _OtherPreview["default"],
    type: i
  };
}

function getStyleMeasurement(a) {
  return "string" == typeof a ? a : "".concat(a, "px");
}

var AssetPreviewBase = function AssetPreviewBase(a) {
  var b = a.asset,
      c = a.canPlayVideo,
      d = a.canPlayAudio,
      e = a.hideFileTypeIcon,
      f = a.darkMode,
      g = a.smallFont,
      h = getPreviewComponentFromAsset(b, {
    canPlayVideo: c,
    canPlayAudio: d
  }),
      i = h.component,
      j = h.type,
      k = (0, _objectWithoutProperties2["default"])(h, ["component", "type"]);
  return _react["default"].createElement(i, (0, _extends2["default"])({
    asset: b,
    type: j,
    hideFileTypeIcon: e,
    darkMode: f,
    smallFont: g
  }, k));
};

function AssetPreview(a) {
  var b = a.asset,
      c = a.canPlayVideo,
      d = a.canPlayAudio,
      e = a.width,
      f = void 0 === e ? "100%" : e,
      g = a.height,
      h = void 0 === g ? 130 : g,
      i = a.hideFileTypeIcon,
      j = a.darkMode,
      k = a.smallFont,
      l = a.rounded;
  if (b === void 0) return null;
  var m = getStyleMeasurement(h),
      n = getStyleMeasurement(f);
  return _react["default"].createElement("div", {
    className: "asset-preview",
    style: _objectSpread({
      height: m,
      minHeight: m,
      width: n,
      minWidth: n
    }, l ? {
      borderRadius: "4px"
    } : {})
  }, _react["default"].createElement(AssetPreviewBase, {
    asset: b,
    canPlayVideo: c,
    canPlayAudio: d,
    hideFileTypeIcon: i,
    darkMode: j,
    smallFont: k
  }));
}

var _default = (0, _react.memo)(AssetPreview);

exports["default"] = _default;